import React from "react";
import { Pagination, PaginationItem, PaginationLink, Input } from "reactstrap";
import { FormattedMessage } from "react-intl";

const PAGE_WINDOW = 5;

function getPageNumbers(totalPages, currentPage) {
  const pages = [];
  const rangeStart = Math.max(2, currentPage - PAGE_WINDOW);
  const rangeEnd = Math.min(totalPages - 1, currentPage + PAGE_WINDOW);

  pages.push(1);
  if (rangeStart > 2) {
    pages.push("start-ellipsis");
  }
  for (let page = rangeStart; page <= rangeEnd; page++) {
    pages.push(page);
  }
  if (rangeEnd < totalPages - 1) {
    pages.push("end-ellipsis");
  }
  if (totalPages > 1) {
    pages.push(totalPages);
  }
  return pages;
}

export default function TablePagination({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  pageSizeOptions,
  onPageChange,
  onPageSizeChange,
}) {
  if (totalItems === 0) {
    return null;
  }

  const itemRangeStart = (currentPage - 1) * pageSize + 1;
  const itemRangeEnd = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-2">
      <div className="d-flex align-items-center gap-2">
        <span>
          <FormattedMessage id="ItemsPerPage" />
        </span>
        <Input
          type="select"
          bsSize="sm"
          className="w-auto"
          value={pageSize}
          onChange={(event) => onPageSizeChange(Number(event.target.value))}
        >
          {pageSizeOptions.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </Input>
        <span className="text-muted">
          <FormattedMessage
            id="PaginationItemRange"
            values={{
              start: itemRangeStart,
              end: itemRangeEnd,
              total: totalItems,
            }}
          />
        </span>
      </div>
      {totalPages > 1 ? (
        <Pagination aria-label="Page navigation" className="mb-0">
          <PaginationItem disabled={currentPage === 1}>
            <PaginationLink first onClick={() => onPageChange(1)} />
          </PaginationItem>
          <PaginationItem disabled={currentPage === 1}>
            <PaginationLink
              previous
              onClick={() => onPageChange(currentPage - 1)}
            />
          </PaginationItem>
          {getPageNumbers(totalPages, currentPage).map((page) =>
            typeof page === "string" ? (
              <PaginationItem key={page} disabled>
                <PaginationLink>…</PaginationLink>
              </PaginationItem>
            ) : (
              <PaginationItem key={page} active={page === currentPage}>
                <PaginationLink onClick={() => onPageChange(page)}>
                  {page}
                </PaginationLink>
              </PaginationItem>
            ),
          )}
          <PaginationItem disabled={currentPage === totalPages}>
            <PaginationLink
              next
              onClick={() => onPageChange(currentPage + 1)}
            />
          </PaginationItem>
          <PaginationItem disabled={currentPage === totalPages}>
            <PaginationLink last onClick={() => onPageChange(totalPages)} />
          </PaginationItem>
        </Pagination>
      ) : (
        ""
      )}
    </div>
  );
}
